// import React from "react";
// import Dialog from "@mui/material/Dialog";
// import DialogTitle from "@mui/material/DialogTitle";
// import DialogContent from "@mui/material/DialogContent";
// import Typography from "@mui/material/Typography";
// import Button from "@mui/material/Button";

// export default function StorageUsageDialogInside({ open, setOpen, message }) {
//   const handleClose = () => {
//     setOpen(false);
//   };

//   return (
//     <Dialog open={open} disableEscapeKeyDown maxWidth="xs" fullWidth>
//       <DialogContent
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           padding: "15px",
//         }}
//       >
//         <DialogTitle style={{ fontSize: "1.2rem", textAlign: "center" }}>
//           Limit Warning
//         </DialogTitle>

//         <Typography
//           variant="body2"
//           style={{
//             color: "red",
//             textAlign: "center",
//             marginBottom: "20px",
//             whiteSpace: "pre-line",
//           }}
//         >
//           {message ||
//             "Data and media limit exceeded.\nPlease contact administrator."}
//         </Typography>

//         <Button
//           variant="contained"
//           onClick={handleClose}
//           style={{ backgroundColor: "#d32f2f", color: "#fff", textTransform: "none" }}
//         >
//           OK
//         </Button>
//       </DialogContent>
//     </Dialog>
//   );
// }
import React from "react";
import axios from "axios";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useHistory } from "react-router-dom";
export default function StorageUsageDialogInside({
  open,
  setOpen,
  message,
  shouldLogout,
  onLogout,
}) {
  const refreshToken = sessionStorage.getItem("refreshToken");
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const history = useHistory();

  const Logout = () => {
    axios
      .post(`${REACT_APP_BACKEND_ROUTE_URL}logout/`, {
        refresh_token: refreshToken,
      })
      .then((res) => {
        // console.log(res.status);
        sessionStorage.clear();
        // window.location.reload();
        history.push("/login");
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleClose = () => {
    setOpen(false);

    // Logout if needed
    if (shouldLogout && typeof onLogout === "function") {
      Logout();
    }
  };

  return (
    <Dialog open={open} disableEscapeKeyDown maxWidth="xs" fullWidth>
      <DialogContent
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "15px",
        }}
      >
        <DialogTitle style={{ fontSize: "1.2rem", textAlign: "center" }}>
          Limit Warning
        </DialogTitle>

        <Typography
          variant="body2"
          style={{
            color: "red",
            textAlign: "center",
            marginBottom: "20px",
            whiteSpace: "pre-line",
          }}
        >
          {message ||
            "Data and media limit exceeded.\nPlease contact administrator."}
        </Typography>

        <Button
          variant="contained"
          onClick={handleClose}
          style={{
            backgroundColor: "#d32f2f",
            color: "#fff",
            textTransform: "none",
          }}
        >
          OK
        </Button>
      </DialogContent>
    </Dialog>
  );
}
